
import { Field } from '@/model/table/Field';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import FormSelector from '@/components/form/FormSelector.vue';
import ProjectRole from '@/model/enums/ProjectRole';
import { ProfileResponse } from '@/model/Profile';
import { FormItemWithClass, createFromEnum } from '@/model/form/FormItem';
import { ProjectUser } from '@/model/Project';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import {
    EventResponse,
    InviteUserRequest,
    RemoveUserRequest,
} from '@/model/Event';
import ProjectTableEventSelector from '@/components/customer-project/ProjectTableEventSelector.vue';

@Component({
    components: {
        FormSelector,
        ConfirmationModal,
        ProjectTableEventSelector,
    },
})
export default class ProjectTable extends Vue {
    @Prop() projectUsers!: ProjectUser[];

    @Prop() projectRole!: string;

    @Prop() profile!: ProfileResponse;

    @Prop() loading!: boolean;

    @Prop({ default: false }) disabled!: boolean;

    @Prop() options!: Array<EventResponse>;

    roles: { text: string; value: ProjectRole | null }[] = [];

    hover = false;

    currentPage = 1;

    perPage = 8;

    get getOptions(): Array<{ id: number; name: string }> {
        return this.options.map((option) => {
            return { id: option.id, name: option.name };
        });
    }

    getEventIds(id: number): Array<number> | undefined {
        return this.projectUsers.find((user) => user.id === id)?.eventIds;
    }

    get itemsForList(): ProjectUser[] {
        return this.projectUsers?.slice(
            (this.currentPage - 1) * this.perPage,
            this.currentPage * this.perPage,
        );
    }

    canEditProjectUserRole(projectUser: ProjectUser): boolean {
        return (
            this.projectRole === 'ADMINISTRATOR' &&
            projectUser.id !== this.profile?.id
        );
    }

    @Emit('remove')
    onRemove(projectUser: ProjectUser): number {
        return projectUser.id;
    }

    @Emit('change')
    onChange(
        role: FormItemWithClass<ProjectRole | null>,
        id: number,
    ): { role: FormItemWithClass<ProjectRole | null>; id: number } {
        return { role, id };
    }

    get types(): FormItemWithClass<ProjectRole | null>[] {
        return createFromEnum<ProjectRole | null>(
            ProjectRole,
            'customer-project.role.type.',
        );
    }

    get getFields(): Field[] {
        const fields = [
            {
                key: 'name',
                label: this.$i18n.t('customer-project.field.name').toString(),
                tdClass: 'align-middle',
            },
            {
                key: 'email',
                label: this.$i18n.t('customer-project.field.email').toString(),
                tdClass: 'align-middle',
            },
            {
                key: 'phone',
                label: this.$i18n.t('customer-project.field.phone').toString(),
                tdClass: 'align-middle',
            },
            {
                key: 'role',
                label: this.$i18n.t('customer-project.field.role').toString(),
                tdClass: 'align-middle',
            },
        ];
        if (this.projectRole === 'ADMINISTRATOR') {
            fields.push(
                {
                    key: 'event',
                    label: this.$i18n
                        .t('customer-project.field.event')
                        .toString(),
                    tdClass: 'align-middle',
                },
                {
                    key: 'actions',
                    label: '',
                    tdClass: 'align-middle',
                },
            );
        }
        return fields;
    }

    @Emit('on-select-event')
    onSelectEvent(id: number, projectUserId: number): InviteUserRequest {
        return { eventId: id, userId: projectUserId };
    }

    @Emit('on-remove-event')
    onRemoveEvent(id: number, projectUserId: number): RemoveUserRequest {
        return { eventId: id, userId: projectUserId };
    }
}
